export default {
  FETCH_SEGMENTS_REQUEST: 'FETCH_MAILCHIMP_SEGMENTS_REQUEST',
  FETCH_SEGMENTS_SUCCESS: 'FETCH_MAILCHIMP_SEGMENTS_SUCCESS',
  FETCH_SEGMENTS_FAILURE: 'FETCH_MAILCHIMP_SEGMENTS_FAILURE',
  RESET_SEGMENTS: 'RESET_MAILCHIMP_SEGMENTS',
  SYNC_SEGMENTS_REQUEST: 'SYNC_MAILCHIMP_SEGMENTS_REQUEST',
  SYNC_SEGMENTS_SUCCESS: 'SYNC_MAILCHIMP_SEGMENTS_SUCCESS',
  SYNC_SEGMENTS_FAILURE: 'SYNC_MAILCHIMP_SEGMENTS_FAILURE'
}
